import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-post-medium-loading',
  templateUrl: './post-medium-loading.component.html',
  styleUrls: ['./post-medium-loading.component.scss'],
  standalone: false,
})
export class PostMediumLoadingComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
